import { defineStyle } from '@chakra-ui/styled-system';

const numericStyles = {
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
};
const baseStyle = {
  container: {
    display: "block",
    whiteSpace: "nowrap",
    WebkitOverflowScrolling: "touch",
    overflowY: "hidden",
    maxWidth: "100%",
    bg: "surface",
    padding: "100",
    borderRadius: "md"
  },
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full",
    borderRadius: "menuList"
  },
  th: {
    textStyle: "heading-xs",
    textAlign: "start",
    px: "300",
    py: "100",
    ...numericStyles
  },
  tr: {
    display: "table",
    width: "100%",
    tableLayout: "fixed"
  },
  td: {
    textAlign: "start",
    px: "300",
    py: "200",
    fontSize: "sm",
    whiteSpace: "wrap",
    ...numericStyles
  },
  caption: {
    textStyle: "heading-xs",
    mt: "200",
    textAlign: "center",
    fontWeight: "medium",
    px: "300",
    py: "200",
    fontSize: "xs"
  }
};
const variantSimple = {
  th: {
    color: "text-primary",
    borderBottomWidth: "1px",
    borderColor: "stroke",
    ...numericStyles
  },
  td: {
    borderBottomWidth: "1px",
    borderColor: "stroke",
    ...numericStyles
  },
  caption: {
    color: "text-primary"
  },
  tfoot: {
    tr: {
      "&:last-of-type": {
        th: { borderBottomWidth: 0 }
      }
    }
  }
};
const variantStripe = {
  th: {
    color: "text-primary",
    ...numericStyles
  },
  td: {
    ...numericStyles
  },
  caption: {
    color: "text-primary"
  },
  tbody: {
    tr: {
      "&:nth-of-type(odd)": {
        td: {
          backgroundColor: "fill-component-secondary"
        }
      }
    }
  },
  tfoot: {
    tr: {
      "&:last-of-type": {
        th: { borderBottomWidth: 0 }
      }
    }
  }
};
const variants = {
  simple: variantSimple,
  striped: variantStripe,
  unstyled: defineStyle({})
};
const Table = {
  baseStyle,
  variants,
  defaultProps: {
    variant: "simple"
  }
};

export { Table };
